





















import { mapGetters } from "vuex";
import Vue from 'vue';
import OctDepotDataTable from "@/common/components/OctDepotDataTable.vue";
import {
  DEPOTS_LOADED,
  DEPOTS_STORE,
  DEPOTS,
  FETCH_DEPOTS,
  DepotsFetchParameters,
  DEPOTS_LOADING
} from "@/common/store/modules/DepotsStore";
import { TranslateResult } from 'vue-i18n';

interface Data {
  statusFilterItems: Array<{ text: TranslateResult; value: string }>
  statusFilter: Array<string | null>
}

export default Vue.extend({
  name: 'OctDepotFilter',
  components: {
    OctDepotDataTable
  },
  data(): Data {
    return {
      statusFilterItems: [
        {
          text: this.$t('depot_status_created'),
          value: 'CREATED'
        },
        {
          text: this.$t('depot_status_pending'),
          value: 'PENDING'
        },
        {
          text: this.$t('depot_status_connected'),
          value: 'CONNECTED'
        },
        {
          text: this.$t('depot_status_declined'),
          value: 'DECLINED'
        },
        {
          text: this.$t('depot_status_invalid'),
          value: 'INVALID'
        },
      ],
      statusFilter: []
    };
  },
  computed: {
    ...mapGetters(DEPOTS_STORE, [DEPOTS, DEPOTS_LOADED, DEPOTS_LOADING]),
  },
  watch: {
    statusFilter (newValue) {
      this.$store.dispatch(FETCH_DEPOTS, { filter: '', linkStatus: newValue } as DepotsFetchParameters);
    }
  },
  mounted() {
    if (this.$route.query.linkStatus && typeof this.$route.query.linkStatus == 'string') {
      this.statusFilter.push(this.$route.query.linkStatus);
    } else {
      this.$store.dispatch(FETCH_DEPOTS, { filter: '', linkStatus: this.statusFilter } as DepotsFetchParameters);
    }
  }
});
